module.exports = __webpack_public_path__ + "static/img/relief03.e5d4a3a.bmp";


//////////////////
// WEBPACK FOOTER
// ./src/views/reliefVase/imgs/relief03.bmp
// module id = fmTG
// module chunks = 2